 
import { ACTIONS } from "../../../Models/ENUM";
import CONQUER from "../../CONQUER";
import LOG, { log } from "../../../UTIL/LOG";
import GameInstance from "../GameInstance";
import TimerInstance from "../../../UTIL/Instances/TimerInstance";
import DATE from "../../../UTIL/DATE";

class GameCurrency
{
    private currencyID      : any;
    private conquer         : CONQUER;
    public value            : number = 0;
    private gameID          : any;
    private name            : string = "";

    public max              : number = 0;
    private time            : number = 0;
    private Timer           : TimerInstance | any;
    private lastCollected   : number = 0;
    private gameInstance    : GameInstance;
    private collectedID     : string = "";
    private consumedID      : string = "";
    private lastConsumed    : number = 0;

    constructor( gameInstance:GameInstance )
    {
        this.gameInstance   = gameInstance;
        this.conquer        = gameInstance.conquer;
    }

    public fill( data:any )
    {
        this.currencyID     = data._id;
        this.value          = data.value;
        this.gameID         = data.gameID;
        this.name           = data.name;
        this.collectedID    = "$C_"+this.name;
        this.consumedID     = "$Co_"+this.name;
        this.lastCollected  = this.gameInstance.Data.data[ this.collectedID ] || 0;
        this.lastConsumed   = this.gameInstance.Data.data[ this.consumedID ] || 0;

        var self            = this;

        if( this.name === "Energy" )
        {
            this.max    = 20;
            this.time   = 1800000;
            
            if( !this.Timer ) this.Timer  = new TimerInstance({ id:this.name + "Timer", duration:this.time, Signal:this.gameInstance.Signal, onTimeUp:function(){ self.onTimeUp()  }}); 
 
            if( !this.lastCollected )
            {
                this.lastCollected = this.gameInstance.Data.set( this.collectedID, DATE.now() );
                if( !this.value ) this.increase( 20 );
            }

            this.startTimer();
        }

        if( this.name === "Gem" )
        {
            if( !this.value && !this.lastConsumed ) this.increase( 100 );
        }
    }

    public async increase( amount:number ) : Promise<any>
    {
        if( !amount ) return Promise.resolve( this.value );

       // let data    = await 
        this.conquer.do( ACTIONS.GAME_CURRENCY_CHANGE, { _id:this.currencyID, increase:amount } );

        if( amount> 0 ) this.gameInstance.Data.increaseTotal( this.name, amount );
 
        return Promise.resolve( this.onChange( this.value+amount ) );
    }

    public async decrease( amount:number ) : Promise<any>
    {
        this.lastConsumed = this.gameInstance.Data.set( this.consumedID, DATE.now() );
        return this.increase( -amount );
    }

    public async get() : Promise<any>
    {
        let data    = await this.conquer.do( ACTIONS.GAME_CURRENCY_GETONE, { _id:this.currencyID } );
        return Promise.resolve( this.onChange( data.value ) );
    }

    private onChange( value:number )
    {
        this.value = value;

        this.gameInstance.Data.display( this.name, this.value );
        return value;
    }

    private onTimeUp()
    {
        let leftover = this.Timer.elapsed - this.time;

        this.startTimer();
        this.lastCollected = this.gameInstance.Data.set( this.collectedID, DATE.now() );

        if( this.value >= this.max ) return;

        let inc     : number = 5;
        let refill  : number = 0;

        do{
            refill      += inc;
            leftover   -= this.time;

            if( this.value + refill >= this.max ) break;
            
        } while( leftover > this.time );
 
        if( this.value + refill > this.max ) refill = this.max - this.value;
 
        if( refill > 0 ) this.increase( refill );
    }

    private startTimer()
    {
        //log("startTimer", this.name, this.lastCollected );

        this.Timer.start({ startTime:this.lastCollected });
        
    }
}

export default GameCurrency;